import { cx } from "@emotion/css";
import type { RefineThemedLayoutV2Props } from "@refinedev/antd";
import { ThemedLayoutContextProvider } from "@refinedev/antd";
import { useInvalidate } from "@refinedev/core";
import { useIsFetching, useQueryClient } from "@tanstack/react-query";
import { Grid, Layout as AntdLayout } from "antd";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header, Sider } from "ui";
import { ErrorBoundary } from "ui/error";
import { useTempStore } from "utils";

export const GlobalLayout: React.FC<RefineThemedLayoutV2Props> = ({
  children,
  Title,
  Footer,
  OffLayoutArea,
  initialSiderCollapsed,
}) => {
  const breakpoint = Grid.useBreakpoint();
  const isSmall = typeof breakpoint.sm === "undefined" ? true : breakpoint.sm;
  const { pathname } = useLocation();
  const isFetching = useIsFetching();
  const { refreshCallback } = useTempStore();
  const invalidate = useInvalidate();
  const queryClient = useQueryClient();

  const refresh = () => {
    // queryClient.refetchQueries({ type: "active" });
    // queryClient.invalidateQueries({
    //   refetchType: "active",
    //   queryKey: ["infinite"],
    // });
    refreshCallback?.();
    invalidate({ invalidates: ["all"] });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <ThemedLayoutContextProvider initialSiderCollapsed={initialSiderCollapsed}>
      <AntdLayout className="!h-screen" hasSider>
        <Sider
          icon={<img className="object-contain" src={LOGO_BASE_64} />}
          onRefresh={refresh}
          refreshState={!!isFetching}
          Title={Title}
        />
        <AntdLayout>
          <Header isAdmin={true} />
          <AntdLayout.Content style={{ display: "flex", flexDirection: "column" }}>
            <div className={cx("flex h-screen flex-1 flex-col overflow-auto", "p-4")}>
              <ErrorBoundary key={pathname}>{children}</ErrorBoundary>
            </div>
            {OffLayoutArea && <OffLayoutArea />}
          </AntdLayout.Content>
          {Footer && <Footer />}
        </AntdLayout>
      </AntdLayout>
    </ThemedLayoutContextProvider>
  );
};

const LOGO_BASE_64 =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEbSURBVHgBrZS9SgNBFEbPnWxiBCOYJoIIsdIXsFesfBoL7QQrayEvYOEL+AgpRFLZaJvCRitRxEh2TXY/b+IPCgpJdg8sO3zMHOYyd8biTPcGS8yAr3sRXGTG/rzZ7Th7y9T2cIt8PA4GbC/M2XWQsefBM/moV8q0+Ng1JNIG4syHm5MaJFoZDErGwWc0THosh9GoAq9mdLz0h0mFFogj6P6IonKNmvWlZhBtD5rkxA9nLYSM4yJkXwQvdZcC8WqpUyCBgokmmDP09rgycemtchOV6PZi7qpVTEMa3jYrfhjr/t8Zz04y6Z/vKUl12JMaTMNfon6qI0k1ZuGXTOq4aJU8fMtSnbpskbyMZHGqE4rC38NzimR0lymQd4Neq1o+uws2AAAAAElFTkSuQmCC";
